<template>
  <div>
    <!--Loading-->
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
    <div v-if="fetchQuestions" class="columns is-multiline">
      <div class="column is-12">
        <p v-if="fetchCurrentSkill" class="subtitle is-6 has-text-centered">
          <b>Skill:</b> {{ fetchCurrentSkill.name }}
        </p>
        <b-field>
          <div class="buttons">
            <b-button @click="addNewQuestion()" type="is-info" size="is-small">New Question</b-button>
            <b-button :disabled="!checkedQuestions.length" @click="showQuestionsCopy()" type="is-dark" size="is-small"
              icon-left="content-copy">Copy Questions</b-button>
          </div>
        </b-field>

        <!--Copy Questions to a skill-->
        <b-modal :active.sync="modalCopyQuestionsActive" has-modal-card trap-focus :destroy-on-hide="true"
          aria-role="dialog" aria-modal>
          <copy-skill-questions :questions="selectedQuestionIds" @close="modalCopyQuestionsActive = false"></copy-skill-questions>
        </b-modal>

        <!--Add Question-->
        <b-modal :active.sync="modalSetQuestionActive" has-modal-card trap-focus :full-screen="true"
          :destroy-on-hide="true" aria-role="dialog" aria-modal>
          <set-question :skill_id="skill_id" :question_id="edit_question_id"
            @over="modalSetQuestionActive = false"></set-question>
        </b-modal>

        <b-table :data="fetchQuestions" checkable :checked-rows.sync="checkedQuestions">
          <b-table-column v-slot="props" field="question_index" label="SNo">
            <div v-html="props.index + 1"></div>
          </b-table-column>
          <b-table-column v-slot="props" field="question" label="Question" searchable>
            <div v-html="props.row.question"></div>
          </b-table-column>
          <b-table-column v-slot="props" field="type" label="Type">
            {{ $common.questionType(props.row.type) }}
            <span v-if="props.row.type == 'MCQ'">({{ props.row.mcq.type }})</span>
          </b-table-column>
          <b-table-column v-slot="props" field="created_at" label="Created At">
            <div v-html="$common.formatDate(props.row.created_at)"></div>
          </b-table-column>
          <b-table-column v-slot="props" field="actions" label="">
            <div class="buttons is-right">
              <router-link
                target="_blank"
                :to="{ name: 'quiz', query : {first_question : props.row._id}, params: { kid_id: '6049c7ebe2f97e0013da87ff', grade_subject_id: $route.params.id, category_id, skill_id } }">
                <b-button type="is-dark" size="is-small"
                  icon-left="eye"></b-button>
              </router-link>

              <b-button @click="editQuestion(props.row._id)" type="is-primary" size="is-small"
                icon-left="pencil"></b-button>
              <b-button @click="deleteThisQuestion(props.row._id)" type="is-danger" size="is-small"
                icon-left="delete"></b-button>
            </div>
          </b-table-column>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import SetQuestion from "@/components/Question/SetQuestion";
import CopySkillQuestions from "@/components/Skill/CopySkillQuestions";

export default {
  name: "question-table",
  components: {
    SetQuestion,
    CopySkillQuestions,
  },
  props: {
    skill_id: {
      type: String,
      default: null,
    },
    category_id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      modalSetQuestionActive: false,
      modalCopyQuestionsActive: false,
      isLoading: false,
      current_question_id: null,
      edit_question_id: null,
      checkedQuestions: [],
    };
  },
  computed: {
    ...mapGetters(["fetchQuestions", "getTeacherToken", "fetchCurrentSkill"]),
    selectedQuestionIds() {
      return this.checkedQuestions.map((ques) => ques._id);
    },
  },
  methods: {
    ...mapActions([
      "loadSkillDetails",
      "loadQuestions",
      "createQuestion",
      "editQuestion",
      "deleteQuestion",
    ]),
    showQuestionsCopy() {
      this.modalCopyQuestionsActive = true;
    },
    addNewQuestion() {
      this.edit_question_id = null;
      this.modalSetQuestionActive = true;
    },
    loadAllQuestions({ skill }) {
      this.isLoading = true;
      this.loadQuestions({
        token: this.getTeacherToken,
        filter: {
          skill,
        },
      })
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          let message = err.response.data ? err.response.data : err.response;
          this.$buefy.toast.open({
            message,
            type: "is-danger",
            duration: 2000,
          });
        });
    },
    editQuestion(id) {
      this.modalSetQuestionActive = true;
      this.edit_question_id = id;
    },
    deleteThisQuestion(id) {
      this.$buefy.dialog.confirm({
        title: "Warning",
        message: "Are you sure want to delete this question permanently?",
        type: "is-danger",
        onConfirm: () => {
          this.isLoading = true;
          this.deleteQuestion({
            token: this.getTeacherToken,
            id,
          })
            .then(() => {
              // Removing the delete questions
              this.checkedQuestions = this.checkedQuestions.filter(
                (ques) => ques._id != id
              );
              this.isLoading = false;
              this.$buefy.toast.open({
                message: "Question deleted successfully",
                type: "is-success",
              });
            })
            .catch((err) => {
              this.isLoading = false;
              this.$buefy.toast.open({
                message: err.response.data,
                type: "is-danger",
              });
            });
        },
      });
    },
  },
  watch: {
    skill_id: function (new_val) {
      // If skill changes, then removed the checked boxes
      this.checkedQuestions = [];
      this.loadAllQuestions({ skill: new_val });
      this.loadSkillDetails({
        token: this.getTeacherToken,
        id: this.skill_id,
      });
    },
  },
  created() {
    this.loadSkillDetails({
      token: this.getTeacherToken,
      id: this.skill_id,
    });
    this.loadAllQuestions({ skill: this.skill_id });
  },
};
</script>
